// Configuración de versionado para cache busting
export const APP_VERSION = process.env.REACT_APP_VERSION || '1.0.0';
export const BUILD_TIMESTAMP = process.env.REACT_APP_BUILD_TIMESTAMP || Date.now().toString();

// Función para generar URLs con versionado
export const getVersionedUrl = (url) => {
    if (!url) return url;
    
    // Si la URL ya tiene parámetros de query, agregar el versionado
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}v=${APP_VERSION}&t=${BUILD_TIMESTAMP}`;
};

// Función para agregar versionado a URLs de API
export const getApiUrl = (endpoint) => {
    if (!endpoint) return endpoint;
    
    const separator = endpoint.includes('?') ? '&' : '?';
    return `${endpoint}${separator}v=${APP_VERSION}&t=${BUILD_TIMESTAMP}`;
};

// Función para limpiar cache del navegador
export const clearBrowserCache = () => {
    if ('caches' in window) {
        caches.keys().then(names => {
            names.forEach(name => {
                caches.delete(name);
            });
        });
    }
    
    // Limpiar localStorage y sessionStorage
    localStorage.clear();
    sessionStorage.clear();
};

// Función para limpiar cache del navegador de manera silenciosa
export const silentCacheClear = () => {
    try {
        clearBrowserCache();
        localStorage.setItem('app_version', APP_VERSION);
        console.log('Cache cleared silently');
    } catch (error) {
        console.warn('Error clearing cache:', error);
    }
};
